import { Action } from "redux";

import { APIFailureAction, APIRequestAction } from "@/mk2/helpers/action";

export interface PasswordResetEmailSaveApiAction extends Action {
    readonly usernameOrEmail: string;
}

export const PASSWORD_RESET_EMAIL_SAVE_API_REQUEST = "PASSWORD_RESET_EMAIL_SAVE_API_REQUEST";

export interface PasswordResetEmailSaveApiRequestAction
    extends PasswordResetEmailSaveApiAction, APIRequestAction {
    readonly type: typeof PASSWORD_RESET_EMAIL_SAVE_API_REQUEST;
}

export const PASSWORD_RESET_EMAIL_SAVE_API_SUCCESS = "PASSWORD_RESET_EMAIL_SAVE_API_SUCCESS";

export interface PasswordResetEmailSaveApiSuccessAction extends PasswordResetEmailSaveApiAction {
    readonly type: typeof PASSWORD_RESET_EMAIL_SAVE_API_SUCCESS;
}

export const PASSWORD_RESET_EMAIL_SAVE_API_FAILURE = "PASSWORD_RESET_EMAIL_SAVE_API_FAILURE";

export interface PasswordResetEmailSaveApiFailureAction
    extends PasswordResetEmailSaveApiAction, APIFailureAction {
    readonly type: typeof PASSWORD_RESET_EMAIL_SAVE_API_FAILURE;
}

export const passwordResetEmailSaveApi = {
    request: (usernameOrEmail: string): PasswordResetEmailSaveApiRequestAction => ({
        type: PASSWORD_RESET_EMAIL_SAVE_API_REQUEST,
        usernameOrEmail,
    }),
    success: (usernameOrEmail: string): PasswordResetEmailSaveApiSuccessAction => ({
        type: PASSWORD_RESET_EMAIL_SAVE_API_SUCCESS,
        usernameOrEmail,
    }),
    failure: (usernameOrEmail: string, error: string): PasswordResetEmailSaveApiFailureAction => ({
        type: PASSWORD_RESET_EMAIL_SAVE_API_FAILURE,
        usernameOrEmail,
        error,
    }),
};

export const PASSWORD_RESET_EMAIL_SAVE = "PASSWORD_RESET_EMAIL_SAVE";

export interface PasswordResetEmailSaveAction extends PasswordResetEmailSaveApiAction {
    readonly type: typeof PASSWORD_RESET_EMAIL_SAVE;
    readonly captchaToken: string;
}

export const passwordResetEmailSave = (
    usernameOrEmail: string,
    captchaToken: string = "",
): PasswordResetEmailSaveAction => ({
    type: PASSWORD_RESET_EMAIL_SAVE,
    usernameOrEmail,
    captchaToken,
});
